import React from 'react'
import styled from '@emotion/styled';

const Wrapper = styled.div`
    width: 480px;
    position: absolute;
    background-color: ${props => props.theme.colors.white};
    border-radius: ${props => props.theme.borderRadius.default};
    box-shadow: ${props => props.theme.shadow.modal};
    padding: 30px;
    p {
        margin: 0px;
        line-height: 24px;
    }
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        width: 100%;
    }
`;

const Title = styled.h1`
    font-size: 25px;
    margin: 0px;
    margin-bottom: 30px;
    font-weight: bold;
    text-align: center;
    line-height: 30px;

    @media (max-width: ${props => props.theme.breakpoints.s}) {
        font-size: 18px;
        line-height: 28px;
        margin-bottom: 15px;
    }
`;
const Actions = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 16px;
    > button {
        background-color: ${props => props.theme.colors.blue};
        border-radius: ${props => props.theme.borderRadius.default};
        border: none;
        color: white;
        cursor: pointer;
        width: 50%;
        font-weight: bold;
        padding: 15px 0px;
    }
`;
const Warning = ({title, warnings, handleClick}) => (
    <Wrapper>
        {/* <CloseModalButton onClick={ev => handleClick(false)}/> */}
        <Title>{title}</Title>
        <div>
            {warnings.map(warning =>
                <p key={warning} className="warning">{`${warning}`}</p>
            )}
        </div>
        <Actions>
            <button className="yes" onClick={ev => handleClick(true)}>Ok</button>
        </Actions>
   </Wrapper>
)

export default Warning;